import styled from 'styled-components';

const SubContainerNonCentered = styled.div<{ width?: number }>`
  width: ${({ width }) => width || 600}px;
  max-width: 100%;
`;

const SubContainer = styled(SubContainerNonCentered)({
  marginLeft: 'auto',
  marginRight: 'auto',
});

export { SubContainerNonCentered };
export default SubContainer;
